import { render, staticRenderFns } from "./QuotesArchive.vue?vue&type=template&id=3503d54d&scoped=true&"
import script from "./QuotesArchive.vue?vue&type=script&lang=ts&"
export * from "./QuotesArchive.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesArchive.vue?vue&type=style&index=0&id=3503d54d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503d54d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDatePicker,VMenu,VSelect,VTextField})
